<!-- eslint-disable max-len -->
<template>
  <span class="switch-language-dropdown">
    <bf-dropdown trigger="click" @command="handleSwitchLanguage">
      <bf-row type="flex" class="align-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <mask
            id="mask0_2525_1967"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="3"
            y="3"
            width="15"
            height="15"
          >
            <path d="M3 3H18V18H3V3Z" fill="white" />
          </mask>
          <g mask="url(#mask0_2525_1967)">
            <path
              d="M17.5605 10.5C17.5605 14.3832 14.3832 17.5605 10.5 17.5605C6.61676 17.5605 3.43945 14.3832 3.43945 10.5C3.43945 6.61676 6.61676 3.43945 10.5 3.43945C14.3832 3.43945 17.5605 6.61676 17.5605 10.5Z"
              stroke="white"
              stroke-width="0.761719"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.3786 3.49386L11.862 4.94338C12.056 5.5135 11.6322 6.10547 11.0299 6.10547H10.4997C10.0143 6.10547 9.62079 6.49895 9.62079 6.98437V7.28062C9.62079 7.61121 9.46048 7.94048 9.16818 8.09039C8.45984 8.45367 8.13078 9.27779 8.4868 9.98982L8.74188 10.5L6.74598 9.16939C6.37725 8.92356 6.23897 8.43472 6.4523 8.04627C6.74565 7.51207 6.45263 6.85151 5.86789 6.70532L4.73633 6.42978"
              stroke="white"
              stroke-width="0.761719"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.9395 11.3789C11.2088 11.9176 11.7593 12.2578 12.3616 12.2578H13.1367V13.1367C13.1367 13.6262 12.9367 14.0689 12.6139 14.3876C11.6987 15.2912 10.9067 16.3404 10.5 17.5605L10.183 16.9266C9.81349 16.1875 9.62109 15.3433 9.62109 14.517C9.62109 14.196 9.49356 13.8881 9.26654 13.6611L8.74219 13.1367L9.00413 12.8748C9.37257 12.5063 9.46392 11.9435 9.23089 11.4774L8.74219 10.5H9.51735C10.1196 10.5 10.6701 10.8403 10.9395 11.3789Z"
              stroke="white"
              stroke-width="0.761719"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.1791 5.25164L14.9601 5.90862C14.917 6.03806 14.8443 6.15568 14.7478 6.25216L14.273 6.72694C14.1082 6.89177 14.0156 7.1153 14.0156 7.34842V7.86328C14.0156 8.34867 14.4091 8.74219 14.8945 8.74219C15.3799 8.74219 15.7734 9.13567 15.7734 9.62109V10.2925C15.7734 10.429 15.7417 10.5635 15.6807 10.6856L15.5305 10.9858C15.2383 11.5702 15.6633 12.2578 16.3166 12.2578H17.339"
              stroke="white"
              stroke-width="0.761719"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </svg>
        <span class="current-language-text">{{ currentLanguage?.toUpperCase() }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M11.7895 5.87428C11.5101 5.5979 11.0588 5.5979 10.7794 5.87428L7.99955 8.62396L5.21975 5.87428C4.94033 5.5979 4.48897 5.5979 4.20956 5.87428C3.93015 6.15067 3.93015 6.59714 4.20956 6.87352L7.49804 10.1264C7.77745 10.4028 8.22881 10.4028 8.50822 10.1264L11.7967 6.87352C12.0689 6.60422 12.0689 6.15067 11.7895 5.87428Z"
            fill="white"
          />
        </svg>
      </bf-row>
      <bf-dropdown-menu slot="dropdown">
        <bf-dropdown-item
          v-for="(lang, i) in langs"
          :key="`language-${i}`"
          :command="lang?.value"
          :class="{ 'current-active-language': lang?.value === currentLanguage }"
        >
          {{ lang.label }}
        </bf-dropdown-item>
      </bf-dropdown-menu>
    </bf-dropdown>
  </span>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'SwitchLanguage',
  data() {
    return {
      currentLanguage: Cookies.get('bfc_language') || 'vi',
      langs: [
        { label: 'Tiếng Việt (VI)', value: 'vi' },
        { label: 'English (EN)', value: 'en' },
      ],
    };
  },
  methods: {
    handleSwitchLanguage(language) {
      if (this.currentLanguage === language) {
        return;
      }
      this.currentLanguage = language;
      this.$i18n.locale = language;
      Cookies.set('bfc_language', language, {
        domain: '.bizflycloud.vn',
        path: '/',
        expires: 365,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.current-language-text {
  margin: 0px 4px;
  color: #fff;
  line-height: 22px;
}
.el-dropdown-menu {
  padding: 0px !important;
}
.current-active-language {
  font-weight: 700 !important;
  color: #173ead !important;
}
</style>
